'use client';
import { useContext, useEffect } from 'react';
import { useAnalytics } from '../../../hooks/use-analytics';
import Utils from '../../../utils/utils';
import CategoryPageContext from '../../../context/category-page-context';

// -----------------------------------------------------------------------------
export const CategoryPageTracking = (): JSX.Element => {
  const analytics = useAnalytics();
  const { categoryPage } = useContext(CategoryPageContext);

  // track() waits for the login check and stamps postLogin itself.
  useEffect(() => {
    if (!categoryPage) {
      return;
    }

    analytics.track('appstore_game_page_initialized', {
      gameName: categoryPage.name,
      platform: Utils.isMobile() ? 'Mobile' : 'Web',
    });
  }, []);

  return <></>;
};
